<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  methods: {
    rolePermission (roles) {
      return roles.includes((this.user || {}).role)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/userPermission.vue